export enum PreviewChartRefreshType {
	UI_ONLY = 'UI_ONLY',
	DATA_REQUEST = 'DATA_REQUEST'
}
